import React from "react";
import {
  Button,
  Center,
  Group,
  Image,
  Paper,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useStartOCRJob } from "../../hooks/useStartOCR";
import { imgCDN } from "@/constants";

const ImgUrl = `${imgCDN}/Smartwiz-Product/Client-Profile/failedOcr.png`;

interface DocumentScanFailedProps {
  docId?: string | null;
  className?: string;
}

const HELP_URL = "https://hub.smartwiz.io/organize-client-docs";

const DocumentScanFailed: React.FC<DocumentScanFailedProps> = ({
  docId,
  className,
}) => {
  const { mutate: startOCRJob, isPending } = useStartOCRJob(docId ?? "0");

  const handleRescan = (): void => {
    if (!docId) return;
    startOCRJob();
  };

  return (
    <Center mih="60vh" className={className}>
      <Paper
        withBorder
        p="lg"
        radius="md"
        style={{ maxWidth: 640, width: "100%" }}
      >
        <Stack align="center" gap="sm">
          <Image
            src={ImgUrl}
            alt="Document Scan Failed"
            w={120}
            h={120}
            fit="contain"
          />
          <Title order={3} ta="center">
            Document Scan Failed
          </Title>
          <Text c="dimmed" ta="center">
            Sorry, we couldn’t process this document. Please try scanning the
            file again.
          </Text>
          <Group mt="sm">
            <Button
              onClick={handleRescan}
              loading={isPending}
              disabled={!docId}
            >
              Re-scan Document
            </Button>
            <Button
              variant="subtle"
              component="a"
              href={HELP_URL}
              target="_blank"
              rel="noreferrer"
            >
              Why did this happen?
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Center>
  );
};

export default DocumentScanFailed;
